import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import FeatureFlagsService from './featureFlags/FeatureFlagsService';
import { Settings } from './Settings';
import { LicenseInfo } from '@mui/x-license-pro';
import { ErrorBoundary } from './components/ErrorBoundary';
import logger from './Logger';

// Safety net: a single failed fetch (e.g. a fire-and-forget store call when a
// backend is unreachable) must not surface as an unhandled rejection.
window.addEventListener('unhandledrejection', (event) => {
  logger.error('Unhandled promise rejection', event.reason);
  if (process.env.NODE_ENV === 'production') {
    event.preventDefault();
  }
});

(async () => {
  await Settings.getSettings()
  await FeatureFlagsService.init()

LicenseInfo.setLicenseKey(
  '48a06a611c2520ee61102678641d6202Tz0xMjMyMzMsRT0xNzk3NDY1NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI='
);

ReactDOM.render(
  // <React.StrictMode>
  <BrowserRouter>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </BrowserRouter>,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
})();
